<ziq-entity-attribute-icon [hint]="'Assumption'" *ngIf="attributesFlags.hasAssumptions"
    [isActive]="attributesFlags.hasAssumptions" [activeIcon]="'attribution'">
</ziq-entity-attribute-icon>
<ziq-entity-attribute-icon [hint]="'Links'" *ngIf="attributesFlags.hasLinks" [isActive]="attributesFlags.hasLinks"
    [activeIcon]="'link'">
</ziq-entity-attribute-icon>
<ziq-entity-attribute-icon [hint]="'Description'"
    *ngIf="attributesFlags.hasComments && !attributesFlags.isCalibrationSet" [isActive]="attributesFlags.hasComments"
    [activeIcon]="'chat_bubble'" [notActiveIcon]="'chat_bubble_outline'">
</ziq-entity-attribute-icon>
<ziq-entity-attribute-icon [hint]="'Description'"
    *ngIf="attributesFlags.hasDescription && attributesFlags.isCalibrationSet"
    [isActive]="attributesFlags.hasDescription" [activeIcon]="'chat_bubble'" [notActiveIcon]="'chat_bubble_outline'">
</ziq-entity-attribute-icon>
<ziq-entity-attribute-icon [hint]="'Is not calibrated'"
    *ngIf="attributesFlags.isZoneCombination && attributesFlags.IsNotCalibrated"
    [isActive]="attributesFlags.IsNotCalibrated" [activeIcon]="'block'">
</ziq-entity-attribute-icon>
